import React from 'react'
import ReactLoading from 'react-loading'
import {
  withTheme
} from 'styled-components'

const Loading = ({ theme }) => (
  <ReactLoading
    color={ theme.colors.main }
    delay={ 0 }
    type="spin"
  />
)

export default withTheme(Loading)



// WEBPACK FOOTER //
// ./src/components/atoms/Loading/Loading.js